// import './index.scss';
import React, { useEffect, useState } from 'react';
import Logo from "../../components/general/logo"
import qs from 'qs';
import {
    AutoComplete,
    Button,
    DatePicker,
    Checkbox,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    message,
} from 'antd';

import { BaseUrlAuth } from '../../utils';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { errorHandling } from '../../utils/helper';



const VerifyToken: React.FC = (): JSX.Element => {

    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState<string>();

    useEffect(() => {
        axios
            .post(BaseUrlAuth + `/api/v1/auth/verify`, { token: searchParams.get("verification_token") }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                useNavigate()("/");
            })
            .catch((error) => {
                if (error.response.status === 400) {
                    if (error.response.data.detail === 'VERIFY_USER_ALREADY_VERIFIED') {
                        setMessage(
                            'A user is already verified with this e-mail address.'
                        );
                    } else {
                        setMessage("Invalid token!Try again!");
                    }
                }
                if (error.response.status === 422) {
                    setMessage("Invalid token!Try again!");
                }
            });

    }, []
    )

    return (
        <div className="signin-page">
            <div style={{ marginTop: '25vh' }}>
                <Logo {...{ size: 'large' }} />
            </div>
            <p>
                {message}
            </p>
        </div>
    );
};

export default VerifyToken;
